import { pointInPolygon } from "../../utils/pointInPolygon.js";
import type { AreaOfInterest } from "./areaOfInterest.js";

export const containsPoint = (aoi: AreaOfInterest, lat: number, long: number): boolean => {
    if (aoi.polygons && aoi.polygons[0]) {
        const transformedBoundaries = aoi.polygons[0].map((p) => [p.lat, p.lng]);
        const point = [lat, long];
        return pointInPolygon(point, transformedBoundaries);
    }
    return false;
};
